import React, { useState } from "react";
import axios from "../axios";
import { useNavigate, useParams } from "react-router-dom";

function ResetPassword() {
  const [password, setPassword] = useState("");
  const [resetPasswordMessage, setResetPasswordMessage] = useState("");
  const [isVisible, setIsVisible] = useState(true);
  const { userId, verifyToken } = useParams();
  const navigate = useNavigate();

  const handleResetPassword = async (e) => {
    e.preventDefault();
    try {
const response = await axios.post(
  "/users/verifyResetPassword",
  {
    userId,
    verifyToken,
    password,
  }
);  //console.log(response.data.message);
      setResetPasswordMessage(response.data.message);
    } catch (err) {
      setResetPasswordMessage("Something went wrong. That's all we know.");
      console.error(err.response?.data);
      console.error(err.response?.status);
      console.error(err);
    } finally {
      setIsVisible(false);
    }
  };

  return (
    <div className="container">
      <div id="resetPasswordContainer" className="row justify-content-center">
        <div
          className="row col-lg-4 col-md-6 col-sm-10 col-xs-12 justify-content-center"
          style={{
            border: "1px solid gray",
            borderRadius: "15px",
            padding: "20px",
            marginTop: "50px",
          }}
        >
          <h4
            style={{
              marginBottom: "20px",
              textAlign: "center",
            }}
          >
            Enter New Password
          </h4>
          {isVisible ? (
            <form
              onSubmit={handleResetPassword}
              className="row justify-content-center"
            >
              <div className="form-group" style={{ marginBottom: "20px" }}>
                <label
                  htmlFor="password"
                  className="col-form-label col-md-3 col-sm-4 col-xs-5"
                >
                  Password
                </label>
                <input
                  id="password"
                  className="form-control input-lg"
                  name="email"
                  type="password"
                  required
                  value={password}
                  pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" //1 lowercase, 1 uppercase, 1 number, 8+ chars
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              {password !== "" && (
                <div id="passwordPattern">
                  <h6>Password must contain the following:</h6>
                  <p className={password.match(/[a-z]/g) ? "valid" : "invalid"}>
                    A <b>lowercase</b> letter
                  </p>
                  <p className={password.match(/[A-Z]/g) ? "valid" : "invalid"}>
                    A <b>capital (uppercase)</b> letter
                  </p>
                  <p className={password.match(/[0-9]/g) ? "valid" : "invalid"}>
                    A <b>number</b>
                  </p>
                  <p className={password.length > 7 ? "valid" : "invalid"}>
                    Minimum <b>8 characters</b>
                  </p>
                </div>
              )}
              <div className="col-6 text-center">
                <button className="btn btn-md btn-ryoForest" type="submit">
                  Reset
                </button>
              </div>
            </form>
          ) : (
            <>
              <div className="col-12 text-center">
                {resetPasswordMessage !== "" && (
                  <div className="text-center">
                    <p>{resetPasswordMessage}</p>
                  </div>
                )}
              </div>
              <div className="col-6 text-center">
                <p
                  style={{ color: "blue", cursor: "pointer" }}
                  onClick={() => navigate("/login")}
                >
                  Return to login page
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
